/* eslint-disable */ import { dimensionIndicatorComponent, memoEval, sceneEntityObjectPropertiesComponent, sceneEntityObjectRemoteMaterialOverrideComponent, sceneEntityRemoteMaterialOverrideComponent, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const baseDoubleLegComponents = [
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'baseLeft', true).withAlias('BaseDoubleLeg').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$objectName
        ], ($fileUrl, $objectName)=>({
            fileUrl: $fileUrl,
            objectName: $objectName,
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'baseRight', true).withAlias('BaseDoubleLeg').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$objectName
        ], ($fileUrl, $objectName)=>({
            fileUrl: $fileUrl,
            objectName: $objectName,
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'baseCenter', true).withAlias('BaseDoubleLeg').withGradualFilter({
        active: (self)=>self.$visibleCenter
    }).attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$centerObjectName
        ], ($fileUrl, $centerObjectName)=>({
            fileUrl: $fileUrl,
            objectName: $centerObjectName,
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'crossbrace', true).withAlias('BaseDoubleLeg').withGradualFilter({
        active: (self)=>self.hasCrossbrace
    }).attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$crossbraceObjectName
        ], ($fileUrl, $crossbraceObjectName)=>({
            fileUrl: $fileUrl,
            objectName: $crossbraceObjectName,
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'crossbraceSecondary', true).withAlias('BaseDoubleLeg').withGradualFilter({
        active: (self)=>self.$needTwoCrossbraces
    }).attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$crossbraceObjectName
        ], ($fileUrl, $crossbraceObjectName)=>({
            fileUrl: $fileUrl,
            objectName: $crossbraceObjectName,
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'baseLeft', true).withAlias('BaseDoubleLeg').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$offsetZLeft,
            self.$widthShapekeyValue,
            self.$widthScaleZero,
            self.$widthScaleOne,
            self.$scaleShapekeyValue,
            self.$scaleScaleZero,
            self.$scaleScaleOne
        ], ($offsetZLeft, $widthShapekeyValue, $widthScaleZero, $widthScaleOne, $scaleShapekeyValue, $scaleScaleZero, $scaleScaleOne)=>({
            offsetZ: $offsetZLeft,
            morphTargetInfluences: {
                width: {
                    value: $widthShapekeyValue,
                    scaleZero: $widthScaleZero,
                    scaleOne: $widthScaleOne
                },
                scale: {
                    value: $scaleShapekeyValue,
                    scaleZero: $scaleScaleZero,
                    scaleOne: $scaleScaleOne
                }
            }
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'baseRight', true).withAlias('BaseDoubleLeg').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$offsetZRight,
            self.$widthShapekeyValue,
            self.$widthScaleZero,
            self.$widthScaleOne,
            self.$scaleShapekeyValue,
            self.$scaleScaleZero,
            self.$scaleScaleOne
        ], ($offsetZRight, $widthShapekeyValue, $widthScaleZero, $widthScaleOne, $scaleShapekeyValue, $scaleScaleZero, $scaleScaleOne)=>({
            offsetZ: $offsetZRight,
            rotationY: Math.PI,
            morphTargetInfluences: {
                width: {
                    value: $widthShapekeyValue,
                    scaleZero: $widthScaleZero,
                    scaleOne: $widthScaleOne
                },
                scale: {
                    value: $scaleShapekeyValue,
                    scaleZero: $scaleScaleZero,
                    scaleOne: $scaleScaleOne
                }
            }
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'baseCenter', true).withAlias('BaseDoubleLeg').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$centerWidthShapekeyValue,
            self.$centerWidthScaleZero,
            self.$centerWidthScaleOne,
            self.$centerScaleShapekeyValue,
            self.$centerScaleScaleZero,
            self.$centerScaleScaleOne
        ], ($centerWidthShapekeyValue, $centerWidthScaleZero, $centerWidthScaleOne, $centerScaleShapekeyValue, $centerScaleScaleZero, $centerScaleScaleOne)=>({
            morphTargetInfluences: {
                width: {
                    value: $centerWidthShapekeyValue,
                    scaleZero: $centerWidthScaleZero,
                    scaleOne: $centerWidthScaleOne
                },
                scale: {
                    value: $centerScaleShapekeyValue,
                    scaleZero: $centerScaleScaleZero,
                    scaleOne: $centerScaleScaleOne
                }
            }
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'crossbrace', true).withAlias('BaseDoubleLeg').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$crossbraceOffsetY,
            self.$crossbraceOffsetZ,
            self.$crossbraceWidthShapekeyValue,
            self.$crossbraceWidthScaleZero,
            self.$crossbraceWidthScaleOne,
            self.$crossbraceLengthShapekeyValue,
            self.$crossbraceLengthScaleZero,
            self.$crossbraceLengthScaleOne,
            self.$crossbraceHeightShapekeyValue,
            self.$crossbraceHeightScaleZero,
            self.$crossbraceHeightScaleOne,
            self.$crossbraceScaleShapekeyValue,
            self.$crossbraceScaleScaleZero,
            self.$crossbraceScaleScaleOne
        ], ($crossbraceOffsetY, $crossbraceOffsetZ, $crossbraceWidthShapekeyValue, $crossbraceWidthScaleZero, $crossbraceWidthScaleOne, $crossbraceLengthShapekeyValue, $crossbraceLengthScaleZero, $crossbraceLengthScaleOne, $crossbraceHeightShapekeyValue, $crossbraceHeightScaleZero, $crossbraceHeightScaleOne, $crossbraceScaleShapekeyValue, $crossbraceScaleScaleZero, $crossbraceScaleScaleOne)=>({
            offsetY: $crossbraceOffsetY,
            offsetZ: $crossbraceOffsetZ,
            morphTargetInfluences: {
                width: {
                    value: $crossbraceWidthShapekeyValue,
                    scaleZero: $crossbraceWidthScaleZero,
                    scaleOne: $crossbraceWidthScaleOne
                },
                length: {
                    value: $crossbraceLengthShapekeyValue,
                    scaleZero: $crossbraceLengthScaleZero,
                    scaleOne: $crossbraceLengthScaleOne
                },
                height: {
                    value: $crossbraceHeightShapekeyValue,
                    scaleZero: $crossbraceHeightScaleZero,
                    scaleOne: $crossbraceHeightScaleOne
                },
                scale: {
                    value: $crossbraceScaleShapekeyValue,
                    scaleZero: $crossbraceScaleScaleZero,
                    scaleOne: $crossbraceScaleScaleOne
                }
            }
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'crossbraceSecondary', true).withAlias('BaseDoubleLeg').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$crossbraceOffsetY,
            self.$crossbraceSecondaryOffsetZ,
            self.$crossbraceWidthShapekeyValue,
            self.$crossbraceWidthScaleZero,
            self.$crossbraceWidthScaleOne,
            self.$crossbraceLengthShapekeyValue,
            self.$crossbraceLengthScaleZero,
            self.$crossbraceLengthScaleOne,
            self.$crossbraceHeightShapekeyValue,
            self.$crossbraceHeightScaleZero,
            self.$crossbraceHeightScaleOne,
            self.$crossbraceScaleShapekeyValue,
            self.$crossbraceScaleScaleZero,
            self.$crossbraceScaleScaleOne
        ], ($crossbraceOffsetY, $crossbraceSecondaryOffsetZ, $crossbraceWidthShapekeyValue, $crossbraceWidthScaleZero, $crossbraceWidthScaleOne, $crossbraceLengthShapekeyValue, $crossbraceLengthScaleZero, $crossbraceLengthScaleOne, $crossbraceHeightShapekeyValue, $crossbraceHeightScaleZero, $crossbraceHeightScaleOne, $crossbraceScaleShapekeyValue, $crossbraceScaleScaleZero, $crossbraceScaleScaleOne)=>({
            offsetY: $crossbraceOffsetY,
            offsetZ: $crossbraceSecondaryOffsetZ,
            morphTargetInfluences: {
                width: {
                    value: $crossbraceWidthShapekeyValue,
                    scaleZero: $crossbraceWidthScaleZero,
                    scaleOne: $crossbraceWidthScaleOne
                },
                length: {
                    value: $crossbraceLengthShapekeyValue,
                    scaleZero: $crossbraceLengthScaleZero,
                    scaleOne: $crossbraceLengthScaleOne
                },
                height: {
                    value: $crossbraceHeightShapekeyValue,
                    scaleZero: $crossbraceHeightScaleZero,
                    scaleOne: $crossbraceHeightScaleOne
                },
                scale: {
                    value: $crossbraceScaleShapekeyValue,
                    scaleZero: $crossbraceScaleScaleZero,
                    scaleOne: $crossbraceScaleScaleOne
                }
            }
        }))),
    attachComponent.withComponent(sceneEntityObjectRemoteMaterialOverrideComponent, 'baseLeft', true).withAlias('BaseDoubleLeg').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$finishColor,
            self.$textureUrl,
            self.$normalMapUrl,
            self.$roughnessMapUrl,
            self.$aoMapUrl,
            self.$materialRoughness,
            self.$materialMetalness,
            self.$materialEnvMapIntensity,
            self.$materialSpecularIntensity,
            self.$materialNormalScale,
            self.$materialReflectivity,
            self.$repeatX,
            self.$repeatY
        ], ($fileUrl, $finishColor, $textureUrl, $normalMapUrl, $roughnessMapUrl, $aoMapUrl, $materialRoughness, $materialMetalness, $materialEnvMapIntensity, $materialSpecularIntensity, $materialNormalScale, $materialReflectivity, $repeatX, $repeatY)=>({
            materialsToOverride: [
                'SupportMaterial'
            ],
            fileUrl: $fileUrl,
            materialName: 'SupportMaterial',
            color: $finishColor,
            textureUrl: $textureUrl,
            normalMapUrl: $normalMapUrl,
            roughnessMapUrl: $roughnessMapUrl,
            aoMapUrl: $aoMapUrl,
            roughness: $materialRoughness,
            metalness: $materialMetalness,
            envMapIntensity: $materialEnvMapIntensity,
            specularIntensity: $materialSpecularIntensity,
            normalScale: $materialNormalScale,
            reflectivity: $materialReflectivity,
            repeatX: $repeatX,
            repeatY: $repeatY
        }))),
    attachComponent.withComponent(sceneEntityObjectRemoteMaterialOverrideComponent, 'baseRight', true).withAlias('BaseDoubleLeg').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$finishColor,
            self.$textureUrl,
            self.$normalMapUrl,
            self.$roughnessMapUrl,
            self.$aoMapUrl,
            self.$materialRoughness,
            self.$materialMetalness,
            self.$materialEnvMapIntensity,
            self.$materialSpecularIntensity,
            self.$materialNormalScale,
            self.$materialReflectivity,
            self.$repeatX,
            self.$repeatY
        ], ($fileUrl, $finishColor, $textureUrl, $normalMapUrl, $roughnessMapUrl, $aoMapUrl, $materialRoughness, $materialMetalness, $materialEnvMapIntensity, $materialSpecularIntensity, $materialNormalScale, $materialReflectivity, $repeatX, $repeatY)=>({
            materialsToOverride: [
                'SupportMaterial'
            ],
            fileUrl: $fileUrl,
            materialName: 'SupportMaterial',
            color: $finishColor,
            textureUrl: $textureUrl,
            normalMapUrl: $normalMapUrl,
            roughnessMapUrl: $roughnessMapUrl,
            aoMapUrl: $aoMapUrl,
            roughness: $materialRoughness,
            metalness: $materialMetalness,
            envMapIntensity: $materialEnvMapIntensity,
            specularIntensity: $materialSpecularIntensity,
            normalScale: $materialNormalScale,
            reflectivity: $materialReflectivity,
            repeatX: $repeatX,
            repeatY: $repeatY
        }))),
    attachComponent.withComponent(sceneEntityObjectRemoteMaterialOverrideComponent, 'baseCenter', true).withAlias('BaseDoubleLeg').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$finishColor,
            self.$textureUrl,
            self.$normalMapUrl,
            self.$roughnessMapUrl,
            self.$aoMapUrl,
            self.$materialRoughness,
            self.$materialMetalness,
            self.$materialEnvMapIntensity,
            self.$materialSpecularIntensity,
            self.$materialNormalScale,
            self.$materialReflectivity,
            self.$repeatX,
            self.$repeatY
        ], ($fileUrl, $finishColor, $textureUrl, $normalMapUrl, $roughnessMapUrl, $aoMapUrl, $materialRoughness, $materialMetalness, $materialEnvMapIntensity, $materialSpecularIntensity, $materialNormalScale, $materialReflectivity, $repeatX, $repeatY)=>({
            materialsToOverride: [
                'SupportMaterial'
            ],
            fileUrl: $fileUrl,
            materialName: 'SupportMaterial',
            color: $finishColor,
            textureUrl: $textureUrl,
            normalMapUrl: $normalMapUrl,
            roughnessMapUrl: $roughnessMapUrl,
            aoMapUrl: $aoMapUrl,
            roughness: $materialRoughness,
            metalness: $materialMetalness,
            envMapIntensity: $materialEnvMapIntensity,
            specularIntensity: $materialSpecularIntensity,
            normalScale: $materialNormalScale,
            reflectivity: $materialReflectivity,
            repeatX: $repeatX,
            repeatY: $repeatY
        }))),
    attachComponent.withComponent(sceneEntityObjectRemoteMaterialOverrideComponent, 'crossbrace', true).withAlias('BaseDoubleLeg').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$crossbraceFinishColor,
            self.$crossbraceTextureUrl,
            self.$crossbraceNormalMapUrl,
            self.$crossbraceRoughnessMapUrl,
            self.$crossbraceAoMapUrl,
            self.$crossbraceRoughness,
            self.$crossbraceMetalness,
            self.$crossbraceEnvMapIntensity,
            self.$crossbraceSpecularIntensity,
            self.$crossbraceNormalScale,
            self.$crossbraceReflectivity,
            self.$crossbraceRepeatX,
            self.$crossbraceRepeatY
        ], ($fileUrl, $crossbraceFinishColor, $crossbraceTextureUrl, $crossbraceNormalMapUrl, $crossbraceRoughnessMapUrl, $crossbraceAoMapUrl, $crossbraceRoughness, $crossbraceMetalness, $crossbraceEnvMapIntensity, $crossbraceSpecularIntensity, $crossbraceNormalScale, $crossbraceReflectivity, $crossbraceRepeatX, $crossbraceRepeatY)=>({
            materialsToOverride: [
                'SupportMaterial'
            ],
            fileUrl: $fileUrl,
            materialName: 'SupportMaterial',
            color: $crossbraceFinishColor,
            textureUrl: $crossbraceTextureUrl,
            normalMapUrl: $crossbraceNormalMapUrl,
            roughnessMapUrl: $crossbraceRoughnessMapUrl,
            aoMapUrl: $crossbraceAoMapUrl,
            roughness: $crossbraceRoughness,
            metalness: $crossbraceMetalness,
            envMapIntensity: $crossbraceEnvMapIntensity,
            specularIntensity: $crossbraceSpecularIntensity,
            normalScale: $crossbraceNormalScale,
            reflectivity: $crossbraceReflectivity,
            repeatX: $crossbraceRepeatX,
            repeatY: $crossbraceRepeatY
        }))),
    attachComponent.withComponent(sceneEntityObjectRemoteMaterialOverrideComponent, 'crossbraceSecondary', true).withAlias('BaseDoubleLeg').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$crossbraceFinishColor,
            self.$crossbraceTextureUrl,
            self.$crossbraceNormalMapUrl,
            self.$crossbraceRoughnessMapUrl,
            self.$crossbraceAoMapUrl,
            self.$crossbraceRoughness,
            self.$crossbraceMetalness,
            self.$crossbraceEnvMapIntensity,
            self.$crossbraceSpecularIntensity,
            self.$crossbraceNormalScale,
            self.$crossbraceReflectivity,
            self.$crossbraceRepeatX,
            self.$crossbraceRepeatY
        ], ($fileUrl, $crossbraceFinishColor, $crossbraceTextureUrl, $crossbraceNormalMapUrl, $crossbraceRoughnessMapUrl, $crossbraceAoMapUrl, $crossbraceRoughness, $crossbraceMetalness, $crossbraceEnvMapIntensity, $crossbraceSpecularIntensity, $crossbraceNormalScale, $crossbraceReflectivity, $crossbraceRepeatX, $crossbraceRepeatY)=>({
            materialsToOverride: [
                'SupportMaterial'
            ],
            fileUrl: $fileUrl,
            materialName: 'SupportMaterial',
            color: $crossbraceFinishColor,
            textureUrl: $crossbraceTextureUrl,
            normalMapUrl: $crossbraceNormalMapUrl,
            roughnessMapUrl: $crossbraceRoughnessMapUrl,
            aoMapUrl: $crossbraceAoMapUrl,
            roughness: $crossbraceRoughness,
            metalness: $crossbraceMetalness,
            envMapIntensity: $crossbraceEnvMapIntensity,
            specularIntensity: $crossbraceSpecularIntensity,
            normalScale: $crossbraceNormalScale,
            reflectivity: $crossbraceReflectivity,
            repeatX: $crossbraceRepeatX,
            repeatY: $crossbraceRepeatY
        }))),
    attachComponent.withComponent(dimensionIndicatorComponent, 'feetThicknessIndicator', true).withAlias('BaseDoubleLeg').withGradualFilter({
        navigationStates: [
            'Shape',
            'Base',
            'Wood',
            'Appearance',
            'Accessories',
            'Summary'
        ]
    }).attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$feetThicknessIndicatorFixedX,
            self.$feetThicknessIndicatorStartZ,
            self.$feetThicknessIndicatorEndZ
        ], ($feetThicknessIndicatorFixedX, $feetThicknessIndicatorStartZ, $feetThicknessIndicatorEndZ)=>({
            startX: $feetThicknessIndicatorFixedX,
            startY: 0,
            startZ: $feetThicknessIndicatorStartZ,
            endX: $feetThicknessIndicatorFixedX,
            endY: 0,
            endZ: $feetThicknessIndicatorEndZ,
            extrusionX: 12,
            extrusionY: 0,
            extrusionZ: 0,
            extrusionLineDashed: true,
            indicatorAlwaysVisible: false
        }))),
    attachComponent.withComponent(dimensionIndicatorComponent, 'baseThicknessIndicator', true).withAlias('BaseDoubleLeg').withGradualFilter({
        navigationStates: [
            'Shape',
            'Base',
            'Wood',
            'Appearance',
            'Accessories',
            'Summary'
        ],
        active: (self)=>self.$baseThicknessIndicatorVisible
    }).attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$baseThicknessIndicatorFixedY,
            self.$baseThicknessIndicatorStartZ,
            self.$baseThicknessIndicatorEndZ,
            self.$baseThicknessIndicatorExtrusionX
        ], ($baseThicknessIndicatorFixedY, $baseThicknessIndicatorStartZ, $baseThicknessIndicatorEndZ, $baseThicknessIndicatorExtrusionX)=>({
            startX: 0,
            startY: $baseThicknessIndicatorFixedY,
            startZ: $baseThicknessIndicatorStartZ,
            endX: 0,
            endY: $baseThicknessIndicatorFixedY,
            endZ: $baseThicknessIndicatorEndZ,
            extrusionX: $baseThicknessIndicatorExtrusionX,
            extrusionY: 0,
            extrusionZ: 0,
            extrusionLineDashed: true,
            indicatorAlwaysVisible: false
        }))),
    attachComponent.withComponent(sceneEntityRemoteMaterialOverrideComponent, 'woodenInserts', true).withAlias('BaseDoubleLeg').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$crossbraceFinishColor,
            self.$crossbraceTextureUrl,
            self.$crossbraceNormalMapUrl,
            self.$crossbraceRoughnessMapUrl,
            self.$crossbraceAoMapUrl,
            self.$crossbraceRoughness,
            self.$crossbraceMetalness,
            self.$crossbraceEnvMapIntensity,
            self.$crossbraceSpecularIntensity,
            self.$crossbraceNormalScale,
            self.$crossbraceReflectivity
        ], ($fileUrl, $crossbraceFinishColor, $crossbraceTextureUrl, $crossbraceNormalMapUrl, $crossbraceRoughnessMapUrl, $crossbraceAoMapUrl, $crossbraceRoughness, $crossbraceMetalness, $crossbraceEnvMapIntensity, $crossbraceSpecularIntensity, $crossbraceNormalScale, $crossbraceReflectivity)=>({
            materialsToOverride: [
                'InsertMaterial'
            ],
            fileUrl: $fileUrl,
            materialName: 'InsertMaterial',
            color: $crossbraceFinishColor,
            textureUrl: $crossbraceTextureUrl,
            normalMapUrl: $crossbraceNormalMapUrl,
            roughnessMapUrl: $crossbraceRoughnessMapUrl,
            aoMapUrl: $crossbraceAoMapUrl,
            roughness: $crossbraceRoughness,
            metalness: $crossbraceMetalness,
            envMapIntensity: $crossbraceEnvMapIntensity,
            specularIntensity: $crossbraceSpecularIntensity,
            normalScale: $crossbraceNormalScale,
            reflectivity: $crossbraceReflectivity,
            repeatX: 1,
            repeatY: 1
        })))
];

//# sourceMappingURL=base-double-leg.js.map